import styled from 'styled-components';
import colors from '../../theme/search/colors';

const Wrapper = styled.div`
  .container {
    margin: 20px;
    margin-bottom: 40px;
  }

  .result-header {
    width: 100%;

    @media (min-width: 1024px) {
      display: flex;
    }

    @media (max-width: 1024px) {
      width: 100%;
      margin-left: 0;
    }

    > .header {
      background: ${colors.darkerGray};
      color: white;
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-weight: 500;
      min-height: 65px;
      padding-bottom: auto;

      @media (min-width: 1024px) {
        margin-right: 18px;
        min-width: 360px;
      }

      > .text {
        margin-left: 17px;
        text-transform: uppercase;
      }

      > .icon-sidebar {
        cursor: pointer;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 64px;
        height: 100%;
        border-left: 2px solid ${colors.grayFive};

        & div {
          transform: rotate(90deg);
          -webkit-transition: -webkit-transform 0.3s ease-in-out;
          -ms-transition: -ms-transform 0.3s ease-in-out;
          transition: transform 0.3s ease-in-out;

          path {
            stroke: white;
          }
        }
      }
    }

    > .result-pagination {
      width: 100%;
      margin-right: 0px;
    }
  }

  .result-container {
    display: flex;
    position: relative;
    margin-bottom: 50px;

    @media (max-width: 1024px) {
      margin-left: 0;
    }

    & .facet-zone {
      background: ${colors.lightGreyTwo};
      border-bottom: 4px solid ${colors.darkerGray};
      min-width: 360px;
      max-width: 360px;
      margin-right: 18px;

      .close-filters {
        padding-left: 17px;
        padding-right: 20px;
        width: 100%;
        height: 65px;
        text-transform: uppercase;
        font-size: 16px;
        font-weight: 500;
        line-height: 19px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        background-color: ${colors.darkerGray};
        color: white;

        path {
          fill: white;
        }
      }

      @media (max-width: 1024px) {
        position: fixed;
        top: 0;
        left: 0;
        min-width: 100%;
        max-width: 100%;
        height: 100%;
        overflow: scroll;
        margin-right: 0px;
      }
    }

    > .result-zone {
      width: 100%;

      > .result-pagination {
        margin-right: 0px;
        margin-left: 0px;
      }

      > .results {
        display: flex;
        justify-content: space-evenly;
        flex-wrap: wrap;
        margin: 10px;
        margin-top: 0px;
        margin-left: 0px;
        margin-right: 0px;

        @media (max-width: 1024px) {
          margin-right: 0px;
          margin-left: 0px;
        }

        > div:last-child {
          > div {
            margin-right: 0px;
          }
        }

        > div:first-child {
          > div {
            margin-left: 0px;
          }
        }
      }
    }
  }
`;

export { Wrapper };



// WEBPACK FOOTER //
// ./src/pages/Result/style.js